import React, {} from 'react';
export const TripOsContext = React.createContext({});
/**
 * Makes the TripOS facade available to every hook below it. The web app's `main.tsx` builds the facade with
 * `createTripOsApp` and renders this provider once, above the router.
 */
export function TripOsContextProvider({ facade, children }) {
    return React.createElement(TripOsContext.Provider, { value: { facade } }, children);
}
//# sourceMappingURL=TripOsContextProvider.js.map